import React from 'react';

const PageHeader = ({ title, subtitle }) => {
  return (
    <section className="pt-32 pb-20 bg-gradient-to-br from-neutral-light via-white to-primary-light/20 relative">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_40%_25%,rgba(255,87,34,0.05)_0%,rgba(255,255,255,0)_50%)]"></div>
      
      <div className="container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-secondary mb-4">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xl text-secondary-light">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
